import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/bankaccounttypes/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}bankaccounttypes/delete`,
        endpoint: config.endpoints.backend + 'bankaccounttypes/getall'
    }

    let list = {
        labelTitle: 'Lista de Tipos de Conta Bancária',
        labelTitleButtonAdd: 'Incluir novo tipo',
        fieldsShowOnDelete: ['description'],
        showPrintButtons: true,
        columns: [
            {
                name: 'description',
                label: 'Tipo de Conta Bancária',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
